/**
 *
 * @type {typeof import("./zh_TW")}
 *
 */
module.exports = {
  '56676244.ot.check.limit': {
    'code450': 'Exceeded the allowable overtime limit',
  },
  '56676244.leave.limit.apply': {
    'code451': 'Leave request submission should be completed within <%= A %> workdays before the Leave starts.',
    'code452': 'Leave request submission should be completed within <%= A %> calendar days before the Leave starts.',
  },
  '56676244.leave.limit.approve': {
    'code451': 'Leave request should be approved within <%= A %> workdays before the Leave starts.',
    'code452': 'Leave request should be approved within <%= A %> calendar days before the Leave starts.',
  },
  '56676244.leave.error': {
    'code459': '非预期性错误',
  },
};
